const HighFiveHandsIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="194"
      height="193"
      viewBox="0 0 194 193"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M129.262 11.076C129.262 11.076 97.1663 -0.87996 66.0303 17.12C34.8943 35.12 19.5263 71.432 6.2983 100.508C-6.9297 129.584 1.26629 159.44 25.3743 173.308C49.4823 187.176 65.5183 167.384 99.0903 166.836C132.662 166.288 141.758 171.284 169.386 152.34C197.014 133.396 201.49 87.892 179.086 53.896C156.682 19.9 129.262 11.076 129.262 11.076Z"
        fill="#85C553"
      />
      <path
        opacity="0.7"
        d="M129.262 11.076C129.262 11.076 97.1663 -0.87996 66.0303 17.12C34.8943 35.12 19.5263 71.432 6.2983 100.508C-6.9297 129.584 1.26629 159.44 25.3743 173.308C49.4823 187.176 65.5183 167.384 99.0903 166.836C132.662 166.288 141.758 171.284 169.386 152.34C197.014 133.396 201.49 87.892 179.086 53.896C156.682 19.9 129.262 11.076 129.262 11.076Z"
        fill="white"
      />
      <path
        d="M63.9222 91.312L48.3782 99.764"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.4702 45.224L51.1062 51.768"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.3782 8.13599L65.0142 25.316"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M90.6463 0.5L90.1023 14.136"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M121.734 32.9519L135.642 19.0439"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M141.094 61.04L153.094 56.952"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M129.642 91.584L139.73 97.308"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.8342 32.6801L59.0142 38.9521"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M138.914 44.408L130.186 48.496"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.8301 74.132L44.5581 76.856"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M133.458 77.676L137.822 78.768"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M137.194 61.44C135.65 60.372 129.842 61.32 126.166 64.284C122.49 67.248 121.662 68.316 121.662 68.316C121.662 68.316 120.002 56.696 120.002 56.34C120.002 55.9841 117.63 34.168 117.154 30.968C116.678 27.768 115.954 23.024 115.258 21.956C114.562 20.888 111.702 20.756 110.754 21.248L109.806 21.72C109.806 21.72 110.278 13.42 109.33 11.404C108.382 9.38805 105.418 10.576 104.586 11.644C103.995 12.4855 103.518 13.4015 103.166 14.368C103.166 14.368 100.438 13.42 98.8983 16.504C97.3583 19.588 96.1703 22.312 95.9343 25.276C95.6983 28.24 94.3903 32.036 94.3903 32.036C94.3903 32.036 92.8503 29.544 91.1903 30.968C89.5303 32.392 87.6343 37.964 87.1583 41.996C86.6823 46.028 86.2103 56.696 86.2103 56.696C86.2103 56.696 85.2623 61.556 84.7863 65.472C84.3103 69.388 84.6703 85.628 86.4463 92.384C88.2223 99.14 90.5983 103.412 90.5983 103.412C90.5983 103.412 94.7463 117.044 95.3383 118.944C95.9303 120.844 102.454 146.688 102.454 146.688L121.898 122.008C121.898 122.008 117.038 108.612 115.97 105.528C114.902 102.444 114.19 101.496 114.19 101.496C114.19 101.496 120.118 93.096 123.322 90.588C126.526 88.08 128.182 79.788 129.01 76.124C129.838 72.46 133.278 67.352 135.178 65.692C137.078 64.032 138.734 62.508 137.194 61.44ZM93.3223 55.7481C92.9703 55.7481 93.0863 51.1241 93.0863 45.552C93.0863 39.98 94.0343 37.488 94.0343 37.488C93.5623 39.98 94.5103 52.308 94.5103 53.14C94.5103 53.972 93.6783 55.7481 93.3223 55.7481Z"
        fill="white"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M111.254 103.54C112.738 102.788 113.006 101.988 113.006 101.988"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M99.6062 100.808C99.6062 100.808 106.13 105.076 109.33 104.244"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M121.662 68.316C121.662 68.316 119.17 72.228 118.578 73.652C117.986 75.076 117.63 76.26 116.578 76.852C115.526 77.444 114.09 78.276 114.09 78.276"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M114.498 69.4761C111.482 70.8761 107.238 73.3481 104.826 76.9721"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M117.986 68.0801C117.986 68.0801 117.114 68.3481 115.794 68.8801"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M103.522 78.5121C103.522 78.5121 101.386 82.4241 100.438 85.5081"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M103.166 14.368C103.166 14.368 102.57 19.348 101.742 26.808C100.914 34.268 100.438 37.952 100.542 42.696C100.646 47.44 101.978 51.608 101.866 52.192"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M109.806 21.7201C109.589 24.0871 109.589 26.4691 109.806 28.8361C110.158 32.8641 109.45 40.3361 109.45 43.1801C109.45 46.0241 109.566 50.2961 109.686 51.5801C109.771 52.3879 110.055 53.162 110.514 53.8321"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M112.058 54.5641C112.058 54.5641 112.65 55.6281 116.562 55.7641"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M103.066 51.7161C103.066 51.7161 105.91 52.3081 107.81 51.9561"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M92.7302 56.696C92.7302 56.696 92.7302 57.896 89.2942 58.948"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M99.4902 53.496C99.8462 53.26 101.266 52.784 101.622 51.124"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M99.6943 71.656C99.6943 71.656 107.066 68.956 111.734 67.972"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M120.622 191.664H184.358C179.906 185.788 163.662 164.376 162.602 163.316C161.374 162.088 155.966 161.352 155.966 161.352L139.994 148.08L120.09 115.152L101.166 141.448L97.9662 128.648L90.8462 155.208C90.8462 155.208 116.65 186.664 117.646 187.892C117.822 188.128 118.934 189.54 120.622 191.664Z"
        fill="black"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M70.7144 99.48C70.7144 99.48 65.4384 85.968 64.1664 83.48C62.8944 80.992 55.9904 70.188 55.6424 67.26C55.2944 64.332 54.2144 59.452 53.1024 57.412C51.9904 55.372 55.3024 54.036 58.0384 56.612C60.7744 59.188 62.4384 63.412 62.3984 64.612C62.3584 65.812 68.5424 70.352 68.5424 70.352L69.6664 59.952C69.6664 59.952 70.8664 34.116 70.6144 30.26C70.3624 26.404 70.1144 18.216 73.1744 17.9C76.2344 17.584 76.7064 20.008 76.7064 20.008C76.7064 20.008 76.8184 13.904 80.2184 14.3C82.8184 14.6 83.8184 17.052 84.1944 18.228C84.5704 19.404 85.0224 20.876 85.0224 20.876C85.0224 20.876 87.1664 19.42 89.2584 22.876C90.4584 24.876 93.0104 31.132 93.4224 32.724C93.8344 34.316 93.9624 34.892 93.9624 34.892C94.8654 34.9152 95.7411 35.2064 96.4782 35.7284C97.2154 36.2505 97.7807 36.9799 98.1024 37.824C99.3744 40.852 101.182 48.756 102.93 55.288C104 59.453 104.563 63.732 104.606 68.032C104.606 68.032 105.29 89.06 103.882 95.748C102.474 102.436 99.8264 108.148 99.2824 108.68C98.7384 109.212 90.9184 132.312 90.9184 132.312L63.7824 122.252C63.7824 122.252 69.4344 108.368 70.3264 105.34C70.8632 103.435 70.9954 101.439 70.7144 99.48Z"
        fill="white"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.0344 79.7679C65.053 80.4869 65.1687 81.2 65.3784 81.8879"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M67.7105 71.504C66.5919 72.9768 65.7984 74.67 65.3825 76.472C65.2347 77.0621 65.1318 77.6625 65.0745 78.268"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.7065 20.0079C76.7065 20.0079 77.1785 28.4079 77.5065 32.5279C77.8345 36.6479 77.9745 43.0719 78.0025 47.2799C78.0305 51.4879 77.5185 56.7719 77.2305 57.9199C76.9803 58.8092 76.6703 59.6805 76.3025 60.5279"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M85.0225 20.8679C84.6272 21.3635 84.3426 21.938 84.1881 22.5528C84.0335 23.1676 84.0125 23.8083 84.1265 24.4319C84.5705 26.4319 86.6345 37.6559 86.6305 39.2799C86.6265 40.9039 86.7465 55.0199 86.7785 55.9759C86.8105 56.9319 86.1345 60.1479 85.8145 61.4239"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M93.9625 34.892C93.9625 34.892 92.4345 35.048 92.7625 37.44C93.0905 39.832 93.8665 47.604 93.8665 49.768C93.8665 51.932 94.3705 56.936 94.2665 61.652C94.1625 66.368 95.2704 68.008 95.7824 69.208"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M70.3624 66.348C70.3624 66.348 69.8184 69.056 70.5504 70.456C71.2824 71.856 72.2984 74.824 72.2944 76.456"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M75.8423 65.012C75.8423 65.012 75.5543 67.244 75.8703 68.676C76.1475 69.706 76.5877 70.685 77.1743 71.576"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M84.9823 68.5239C84.9823 68.5239 84.6623 70.8839 85.2343 72.3799C85.5785 73.2831 85.9931 74.1578 86.4743 74.9959"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M72.6664 191.664L97.8944 134.74C97.8944 134.74 87.1384 125.852 80.0584 121.208C72.9784 116.564 64.4904 116.684 64.4904 116.684C64.4904 116.684 53.4064 140.304 52.8224 141.808C52.2384 143.312 44.5104 159.316 44.5104 159.316C44.5104 159.316 41.1144 160.516 39.6064 163.24C38.4264 165.368 29.9144 183.808 26.2864 191.684L72.6664 191.664Z"
        fill="#85C553"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M90.5284 138.471C91.6464 137.81 92.0168 136.367 91.3556 135.249C90.6943 134.131 89.2519 133.761 88.1338 134.422C87.0158 135.083 86.6454 136.526 87.3066 137.644C87.9679 138.762 89.4103 139.132 90.5284 138.471Z"
        fill="black"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M88.0584 145.816C87.9455 146.267 87.7012 146.675 87.3564 146.988C87.0117 147.3 86.582 147.503 86.1217 147.572C85.6615 147.64 85.1913 147.57 84.7707 147.371C84.3501 147.172 83.998 146.853 83.759 146.453C83.5199 146.054 83.4046 145.593 83.4277 145.128C83.4508 144.664 83.6112 144.216 83.8886 143.843C84.166 143.469 84.548 143.186 84.9862 143.03C85.4244 142.873 85.8992 142.85 86.3504 142.964C86.65 143.039 86.9319 143.172 87.18 143.356C87.428 143.54 87.6374 143.771 87.7961 144.036C87.9547 144.301 88.0595 144.594 88.1046 144.9C88.1496 145.205 88.1339 145.517 88.0584 145.816Z"
        fill="black"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HighFiveHandsIcon;
